Ext.ns('mx.app.copyright');

mx.app.copyright.getMaxoptraCopyright = function() {
    var c =
        '<div class="text_copy">&copy; ' +
        '<a href="http://www.magenta-technology.com/" target="_blank" class="link_magenta">Magenta Technology</a> ' +
        new Date().format('Y');
    return c;
};
